<template>
    <el-row :gutter="20">
        <el-col :md="24" :sm="24" class="mb-3">
            <el-card class="profile" shadow="never">
                <div slot="header" class="">

                    <b style="font-size:18px;color: green;margin-top: 5px;padding-right:10px;">{{user.name}}</b>
                    <div v-if="user.disabled" class="text-danger ml-1" style="display: inline-block;">
                        您的账户未激活,{{preset.app.activate_notice}}
                    </div>
                    <span class="text-danger ml-2"
                          v-if="!user.disabled && ( null == profile.email || 0 === profile.email.length )">
                        | 您需要输入邮箱和手机才可以继续使用其他功能。
                    </span>

                </div>

                <div class="mt-3">
                    <el-form :model="profile" ref="profile" label-width="100px" class="">
                        <el-form-item prop="user_id" label="登录名">
                            <el-input v-model="profile.user_id" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item
                                prop="name"
                                label="姓名"
                                :rules="[{ required: true, message: '请输入姓名', trigger: 'blur' },]">
                            <el-input :disabled="true" v-model="profile.name" placeholder="您需填写姓名才可以继续使用其他功能。"></el-input>
                        </el-form-item>
                        <el-form-item prop="email"
                                      label="邮箱"
                                      :disabled="user.email"
                                      :rules="[{ required: true, message: '请输入邮箱', trigger: 'blur' },
                                      { type: 'email', message: '请输入正确格式的邮箱', trigger: 'blur' }]">
                            <el-input v-model="profile.email" placeholder="您需要输入邮箱才可以继续使用其他功能。"></el-input>
                        </el-form-item>
                        <el-form-item
                                prop="department"
                                placeholder="请输入部门"
                                label="部门">
                            <el-input v-model="profile.department" disabled></el-input>
                        </el-form-item>
                        <el-form-item
                                prop="mobile"
                                label="手机"
                                :rules="mobile_rule"
                                v-if="$organization.org!=='sjtu' && !$organization.no_tencent"
                                >
                            <el-input v-model="profile.mobile" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item v-if="!user.disabled && !$organization.use_label">
                            <el-button type="primary" @click="submitForm">提交</el-button>
                            <el-button @click="resetForm">重置</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </el-card>
            <div class="pull-right mt-4 small" style="color:#ddd;">{{$organization.build_time}}</div>
        </el-col>
    </el-row>

</template>

<script>

    import Profile from "@/views/mixins/profile";
    export default {
        name: "profile",
        mixins:[Profile],
    }
</script>

<style scoped lang="scss">

    .profile {

        .image {
            width: 36px;
            height: 36px;
        }
    }


</style>
